/** BootstrapVue tooltip config that escapes fixed/sticky/overflow containers. */
export function viewportTooltip(title, options = {}) {
  return {
    title,
    container: 'body',
    boundary: 'viewport',
    ...options,
  };
}
